module.exports = __webpack_public_path__ + "static/media/max-k-10.8de40ed3.png";